var _defs, _path, _rect, _path2, _path3, _rect2, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoTextSimpleWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.89 76.83",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.7,27.15H75.78a1.72,1.72,0,0,0-1.56,1L64.28,49.57l-10-21.42a1.72,1.72,0,0,0-1.56-1H43.14a1.74,1.74,0,0,0-1.56,1L31.65,49.56l-9.86-21.4a1.7,1.7,0,0,0-1.56-1h-18A1.73,1.73,0,0,0,.75,28a1.75,1.75,0,0,0-.06,1.69L24.59,75.4a1.7,1.7,0,0,0,1.53.93H36.64a1.73,1.73,0,0,0,1.56-1L48,53.74l9.75,21.58a1.75,1.75,0,0,0,1.57,1H69.81a1.7,1.7,0,0,0,1.52-.93L95.22,29.67a1.72,1.72,0,0,0-1.52-2.52Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.01,
    y: 27.15,
    width: 19.67,
    height: 49.18,
    rx: 1.72
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.84.5a10.82,10.82,0,1,0,10.82,10.81A10.82,10.82,0,0,0,113.84.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.15,27.15H207.23a1.69,1.69,0,0,0-1.55,1l-10,21.42-9.94-21.42a1.71,1.71,0,0,0-1.55-1h-9.63a1.72,1.72,0,0,0-1.57,1l-9.95,21.41-9.84-21.4a1.73,1.73,0,0,0-1.57-1h-18a1.72,1.72,0,0,0-1.52,2.52L156,75.4a1.7,1.7,0,0,0,1.52.93h10.53a1.72,1.72,0,0,0,1.56-1l9.76-21.58,9.76,21.58a1.73,1.73,0,0,0,1.57,1h10.52a1.7,1.7,0,0,0,1.52-.93l23.9-45.73a1.73,1.73,0,0,0-1.53-2.52Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 235.74,
    y: 27.15,
    width: 19.67,
    height: 49.18,
    rx: 1.72
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.57,22.13a10.82,10.82,0,1,0-10.81-10.82A10.83,10.83,0,0,0,245.57,22.13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTextSimpleWhite);
export default __webpack_public_path__ + "static/media/logo-text-simple-white.e035f82bc11c0f5ae2b881425c7edc8f.svg";
export { ForwardRef as ReactComponent };